import { Gray, Main, White } from '@constants/color';
import { css } from '@emotion/react';

export const button = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '10px 32px',
  height: '60px',
  backgroundColor: Gray.Gray70,
  borderRadius: '6px',
  color: Gray.Gray50,
  fontSize: '24px',
  fontWeight: 700
});
export const focusedButton = css({
  backgroundColor: Main.priBlue,
  color: White.White10
});

export const icon = css({
  minWidth: '40px',
  minHeight: '40px',
  margin: '0 0 0 4px',
  fill: Gray.Gray80
});
export const focusedIcon = css({
  minWidth: '40px',
  minHeight: '40px',
  margin: '0 0 0 4px',
  fill: White.White10
});
